
if ($('.products-related-header .brandArrows').length === 0) {
  $('.products-related-header')
    .append('<div class="brandArrows"></div>');
}

$('.type-detail .products.products-related.products-additional').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  appendArrows: $('.products-related-header .brandArrows'),
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
    { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
  ]
});


if ($('.in-index').length) {
  $('.in-index .products').prev('.h4').each(function () {
    if ($(this).find('.brandArrows').length === 0) {
      $(this).append('<span class="brandArrows"></span>');
    }
  });

  $('.in-index .products:not(#products-24)').each(function () {
    const $this = $(this);
    const $arrows = $this.prev('.h4').find('.brandArrows');
    $this.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 5000,
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      appendArrows: $arrows, // 💡 šipky půjdou právě do této .brandArrows
      responsive: [
        { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, dots: false, } },
        { breakpoint: 479, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false, } }
      ]
    });
  });
}


if ($('.favoriteBrands .homepage-group-title .brandArrows').length === 0) {
  $('.favoriteBrands .homepage-group-title')
    .append('<div class="brandArrows"></div>');
}


$('.brandsFeed').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  appendArrows: $('.favoriteBrands .brandArrows'),
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 5, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false } },
    { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false } },
    { breakpoint: 400, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
    { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
  ]
});






if ($('.id-1049').length) {
  $('.whyUs .items').prev('.h4').each(function () {
    if ($(this).find('.brandArrows').length === 0) {
      $(this).append('<span class="brandArrows"></span>');
    }
  });

  $('.whyUs .items').each(function () {
    const $this = $(this);
    const $arrows = $this.prev('.h4').find('.brandArrows');
    $this.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 5000,
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      appendArrows: $arrows, // 💡 šipky půjdou právě do této .brandArrows
      responsive: [
        { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
        { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
      ]
    });
  });
}


/*
if ($('.id--9').length) {
  $('.related td').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
      { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
    ]
  });
}*/